import React from 'react';
import PropTypes from 'prop-types';

import './Special.css';
import SpecialVariant from './Special.variant';

const Specials = props => {
  const { header, type, ...rest } = props;
  const Special = SpecialVariant[type];

  return (
    <React.Fragment>
      {header}
      <Special {...rest} />
    </React.Fragment>
  );
};

Specials.propTypes = {
  items: PropTypes.array.isRequired,
  categories: PropTypes.array,
  type: PropTypes.oneOf(['default', 'carousel']),
  header: PropTypes.element,
  autoScroll: PropTypes.bool,
  groupByCategory: PropTypes.bool,
  precision: PropTypes.oneOf([0, 1, 2])
};

Specials.defaultProps = {
  categories: [],
  header: <h1>Specials</h1>,
  type: 'default',
  autoScroll: true,
  groupByCategory: false,
  precision: 2
};

export default Specials;
